<template>
  <el-row>
    <el-col
      style="text-align: right"
      :xl="{ span: 7 }"
      :lg="{ span: 7 }"
      :md="{ span: 7 }"
      :sm="{ span: 2 }"
      :xs="{ span: 2 }"
      
      ><img class="logo hidden-sm-and-down" src="../../static/materials/newlogo.png"
    /></el-col>
    <el-col
      :xl="{ span: 7 ,offset:1}"
      :lg="{ span: 7 ,offset:1}"
      :md="{ span: 7 ,offset:1}"
      :sm="{ span: 24 }"
      :xs="{ span: 24 }"
      ><p style="text-align: left; padding-left: 10px">
        <el-image
          fit="scale-down"
          src="../../static/materials/word.png"
        ></el-image>
      </p>
    </el-col>
  </el-row>
</template>

<script>
module.exports = {
  name: "BannerComponent",
  data() {
    return {};
  },
};
</script>

<style scoped>
.logo {
  margin-top: 30px;
  width: 70px;
  height: 70px;
}
.exp_english {
  font-size: 45px;
  font-family: "Times New Roman", Times, serif;
  color: aliceblue;
  margin-top: 30px;
  text-shadow: -1px 1px 0 #04312c, 1px 1px 0 #04312c;
  text-align: left;
  height: 40px;
}
.exp_chinese {
  font-size: 55px;
  font-family: STLiti;
  color: #092413;
  text-align: left;
  margin-top: 10px;
  font-weight: 500;
  text-shadow: -1px 1px 0 white, 1px 3px 0 white;
  letter-spacing: 25px;
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/bannerComponent.vue